import { DialogTitle } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import {
  Button,
  Card,
  CardContent,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { memo, useEffect } from 'react';
import * as Styled from './styles';
import type { AddCardSuccessProps as Props } from './types';

export const AddCardSuccess = memo(({ className }: Props) => {
  const state = useBoolean();

  useEffect(() => {
    if (window.location.hash.includes('#successAddCard')) {
      state.setValue(true);
    }
  }, [state]);

  const handleClose = () => {
    window.location.hash = '';
    state.onFalse();
  };

  return (
    <Styled.Wrapper
      className={classnames('AddCardSuccess', className)}
      open={state.value}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle
        title="Payment card was added successfully"
        icon="check"
        onClose={handleClose}
      />
      <DialogContent>
        <Card variant="outlined">
          <CardContent padding="extra">
            <Typography variant="body2" fontWeight={600} color="grey.700">
              You’re all set — payment added.
            </Typography>
          </CardContent>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          color="default"
          size="small"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </DialogActions>
    </Styled.Wrapper>
  );
});

AddCardSuccess.displayName = 'AddCardSuccess';
